"use client";

import createSvgIcon from "@mui/material/utils/createSvgIcon";
const Facebook = createSvgIcon(<svg fill="currentColor" viewBox="0 0 8 14">
    <path d="M1.72081 14H4.59374V8.09799H7.18233L7.46667 5.16509H4.59374V3.68421C4.59374 3.27726 4.9153 2.94737 5.31197 2.94737H7.46667V0H5.31197C3.32863 0 1.72081 1.64948 1.72081 3.68421V5.16509H0.284341L0 8.09799H1.72081V14Z" fill="currentColor" />
  </svg>, "Facebook");
export default Facebook;